import React from 'react';
import PropTypes from 'prop-types';
import {
  DtpRadioGroup,
  DtpRadio,
  DtpFormGroup,
  DtpControlLabel,
} from 'dtp-react-components';

const Radio = (props) => {
  const renderSelectItemHorizontal = item => (
    <DtpRadio value={item.value} label={item.label} disabled={props.disabled} />
  );
  const renderSelectItemVertical = item => (
    <p>
      <DtpRadio value={item.value} label={item.label} disabled={props.disabled} />
    </p>
  );

  const optionsButtonListHorizontal = props.itemList.map(item => renderSelectItemHorizontal(item));

  const optionsButtonListVertical = props.itemList.map(item => renderSelectItemVertical(item));

  return (
    <DtpFormGroup>
      <DtpControlLabel
        animate={props.animate}
        label={props.label}
      />
      <DtpRadioGroup
        name={props.name}
        selectedValue={props.value}
        {...props}
      >
        {(props.disposicao === '' || props.disposicao === 'horizontal') ? optionsButtonListHorizontal : optionsButtonListVertical }
      </DtpRadioGroup>
    </DtpFormGroup>
  );
};

Radio.defaultProps = {
  value: null,
  name: null,
  disabled: false,
  label: null,
  animate: false,
  className: null,
  disposicao: null,
};

Radio.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.string,
  animate: PropTypes.bool,
  disposicao: PropTypes.string,
  itemList: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  })).isRequired,
};

export default Radio;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/RadioComLabel.jsx